import {
    VideoImageEnum,
    getVideoImage,
    getVideoImageSrc,
} from '@/components/images/base64/VideoImage';
import { Hall as HallEnum } from '@/models/Hall';
import { ROUTE_ROOT } from '@/models/Route';
import { TableMode } from '@/models/TableMode';
import { GameState } from '@/models/games/enums/GameState';
import { GameType as GameTypeEnum } from '@/models/games/enums/GameType';
import { BetType as PokDengBetType } from '@/models/games/pokdeng/BetType';
import { BetTypeMaxBet } from '@/models/host/MaxBet';
import { Bet as BetRecord } from '@/modules/report/slice/betRecord';
import { getAndarBaharUnavailableBetsForABC } from '@/modules/rwdGame/andarbahar/utils';
import { getBaccaratUnavailableBetsForABC } from '@/modules/rwdGame/baccarat/utils';
import { getSeDieUnavailableBetsForABC } from '@/modules/rwdGame/sedie/utils';
import { getTeenPatti2020UnavailableBetsForABC } from '@/modules/rwdGame/teenpatti/utils';
import md5 from 'md5';
import moment from 'moment';
import { LocalStorageKey } from '../hooks/storage/useLocalStorage';
import { PokerCard, Suit } from '../models/games/PokerCard';
import { ShoeRound } from '../models/games/ShoeRound';
import { Bet, BetPlayerAmount } from '../models/host/BetAmount';
import { Range } from '../modules/main/slice/player';
import { getLocalState as getAndarBaharLocalState } from './games/andarBahar';
import { getLocalState as getBaccaratLocalState } from './games/baccarat';
import { getBlackjackLocalState } from './games/blackjack';
import { getBlackjack2LocalState } from './games/blackjack2';
import { getLocalState as getCarnivalTreasureLocalState } from './games/carnivalTreasure';
import { getLocalState as getDTLocalState } from './games/dragonTiger';
import { getLocalState as getFishPrawnCrabLocalState } from './games/fishprawncrab';
import { getLocalState as getPokDengLocalState } from './games/pokdeng';
import { getLocalState as getRouletteLocalState } from './games/roulette';
import { getLocalState as getSeDieLocalState } from './games/sedie';
import { getLocalState as getSicBoLocalState } from './games/sicbo';
import { getLocalState as getTeenPattiLocalState } from './games/teenpatti';
import { getLocalState as getThaiHiLoLocalState } from './games/thaiHiLo';

type RestMode = {
    isRest: boolean;
    isPause: boolean;
};
export const getIsRestState = (
    restMode: TableMode,
    isTest: boolean
): RestMode => {
    switch (restMode) {
        case TableMode.Open:
            return { isRest: false, isPause: false };
        case TableMode.Close:
            return { isRest: true, isPause: false };
        case TableMode.Pause:
            return { isRest: false, isPause: true };
        case TableMode.InternalTest:
            if (isTest) {
                return { isRest: false, isPause: false };
            } else {
                return { isRest: true, isPause: false };
            }
        case TableMode.InternalTestPause:
            if (isTest) {
                return { isRest: false, isPause: true };
            } else {
                return { isRest: true, isPause: false };
            }
    }
};
export const gotoOldWeb = (): void => {
    try {
        // window.localStorage.setItem(username + '_ui_version2', 'oldWeb');
        let ui = window.localStorage.getItem('fullParameter');
        if (ui) {
            const search = new URLSearchParams(ui);
            const token = search.get('token');
            if (token) {
                const newToken = token.substring(0, token.length - 1) + '2';
                ui = updateParam(ui, 'token', newToken);
            }
            const old_ui_domain = (
                window.location.origin.replace('://ws2.', '://ws.') +
                '/h5web/index.html'
            ).replace('1235/h5web', '5002');
            window.location.href = old_ui_domain + ui;
        }
    } catch (e) {
        console.error(e);
    }
};

export const gotoOldUI = (): void => {
    try {
        let ui = window.localStorage.getItem('fullParameter');
        if (ui) {
            const search = new URLSearchParams(ui);
            const token = search.get('token');
            if (token) {
                const newToken = token.substring(0, token.length - 1) + '2';
                ui = updateParam(ui, 'token', newToken);
            }
            const old_ui_domain =
                window.location.origin.replace('://ws2.', '://ws.') +
                ROUTE_ROOT;
            if (window.location.href.indexOf('://ws.') > 0) {
                window.location.href = old_ui_domain + ui;
            } else {
                window.location.href =
                    old_ui_domain.replace('1235', '1234') + ui;
            }
        }
    } catch (e) {
        console.error(e);
    }
};

export const getWithHold = (GameType: GameTypeEnum): Array<Bet> | undefined => {
    let withHold = new Array<Bet>();
    switch (GameType) {
        case GameTypeEnum.PokDeng:
            withHold.push({
                Type: PokDengBetType.PDBPlayer1Win,
                Amount: 1,
                GameId: 0,
            });
            withHold.push({
                Type: PokDengBetType.PDBPlayer2Win,
                Amount: 1,
                GameId: 0,
            });
            withHold.push({
                Type: PokDengBetType.PDBPlayer3Win,
                Amount: 1,
                GameId: 0,
            });
            withHold.push({
                Type: PokDengBetType.PDBPlayer4Win,
                Amount: 1,
                GameId: 0,
            });
            withHold.push({
                Type: PokDengBetType.PDBPlayer5Win,
                Amount: 1,
                GameId: 0,
            });
    }
    return withHold.length === 0 ? undefined : withHold;
};

export const mergeCurrencyName = (
    serverCurrencyName: string | undefined
): string => {
    if (!serverCurrencyName) return '';
    const num = serverCurrencyName.match(/\d+/g);
    const letr = serverCurrencyName.match(/[a-zA-Z]+/g);
    if (!letr) return serverCurrencyName;
    return num && num[0] == '2' ? letr[0] : serverCurrencyName;
};

export const numberFormat = (
    input: number,
    cc: number = 2,
    dd?: string,
    tt?: string
): string => {
    //let n = input;
    let n: string;
    let c = isNaN((cc = Math.abs(cc))) ? 2 : cc;
    let d = dd == undefined ? '.' : dd;
    let t = tt == undefined ? ',' : tt;
    let s = input < 0 ? '-' : '';
    let i: string = parseInt((n = Math.abs(+input || 0).toFixed(c))) + '';
    let jj = i.length;
    let j = jj > 3 ? jj % 3 : 0;
    return (
        s +
        (j ? i.substr(0, j) + t : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
        (c
            ? d +
              Math.abs(Number(n) - Number(i))
                  .toFixed(c)
                  .slice(2)
            : '')
    );
};

export const calcLowHigh = (range: Range): number => {
    if (!range) return 0;
    const { Low, High } = range;
    let low = Low ?? 0,
        high = High ?? 0;
    let negative: boolean = false;
    let sign: number = 1 << 31;
    if ((high & sign) != 0) {
        negative = true;
        //low = ~low;
        low = ~low;
        high = ~high;
    }
    let result: number = high * 0x100000000 + low;
    if (negative) result = -(result + 1);
    return result;
};

export const getLoginToken = (
    oldToken: string,
    reconnectKey: string
): string => {
    if (!reconnectKey || reconnectKey == '') {
        return oldToken;
    }
    let newToken = md5(oldToken + reconnectKey).toUpperCase();
    return (
        newToken.substring(0, newToken.length - 1) +
        oldToken[oldToken.length - 1]
    );
    // return md5(oldToken + reconnectKey).toUpperCase();
};

export const updateLocalStorageLanguage = (lang: string): void => {
    const pattern: RegExp = new RegExp('lang=([^&]*)', 'i');
    let loginParam = window.localStorage.getItem(LocalStorageKey.FullParameter);
    if (loginParam) {
        loginParam = loginParam.replace(pattern, 'lang=' + lang);
        window.localStorage.setItem(LocalStorageKey.FullParameter, loginParam);
    }

    console.log('app::login::save', lang);
};

export const updateLocalStorageReconnectKey = (
    newToken: string,
    username: string
): void => {
    let loginParam = window.localStorage.getItem(LocalStorageKey.FullParameter);
    if (loginParam) {
        loginParam = updateParam(loginParam, 'token', newToken);
        loginParam = updateParam(loginParam, 'username', username);
        window.localStorage.setItem(LocalStorageKey.FullParameter, loginParam);
    }
    console.log('app::login::save', newToken);
};

export const updateParam = (
    str: string,
    key: string,
    value: string
): string => {
    const pattern: RegExp = new RegExp(`${key}=([^&]*)`, 'i');
    return str.replace(pattern, `${key}=${value}`);
};

export const ExchangeBetAmountByCurrency = (
    betAmount: number,
    rate: number,
    exchangeRate: number
) => {
    if (rate === exchangeRate) {
        return betAmount;
    }
    return Math.ceil((betAmount * rate) / exchangeRate / 100) * 100;
};

export const ExchangeBetAmount = (
    betAmount: number | undefined,
    exchangeRate: number
): number => {
    if (!betAmount) betAmount = 0;
    if (exchangeRate != 100000000) {
        if (exchangeRate < 999999 && exchangeRate >= 100) {
            exchangeRate = Math.floor(exchangeRate / 100) * 100;
        }
        betAmount =
            Math.ceil((betAmount * 100000000) / exchangeRate / 100) * 100;
    } else {
        betAmount = Math.ceil(betAmount / 100) * 100;
    }
    return betAmount;
};

export const getBetSummary = (
    BetAmount: BetPlayerAmount | undefined,
    exchangeRate: number,
    isRest: boolean = false
): string => {
    let b = '0',
        bpc = 0;
    if (BetAmount && isRest === false) {
        b = numberFormat(
            ExchangeBetAmount(BetAmount.Amount, exchangeRate) / 100,
            0
        );
        bpc = BetAmount.BetPlayerCount;
    }
    return `${b}/${bpc}`;
};

export const sleep = async (ms: number) => {
    return new Promise(resolve => {
        const sleepId = setTimeout(() => {
            resolve(sleepId);
        }, ms);
    });
};

export const updateRemainTime = (value: number) => {
    let _countDownFinishTime: number = moment().valueOf();
    if (value !== 0) {
        _countDownFinishTime = moment().valueOf() + (value - 1) * 1000;
    }
    return _countDownFinishTime;
};

export const windowClose = () => {
    window.close();
};

export const getShoeRoundByGameCount = (gameCount: number): ShoeRound => ({
    Shoe: Math.floor(gameCount / 10000),
    Round: gameCount % 10000,
});

export const getPokerByIndex = (i?: number): PokerCard | undefined => {
    if (i === undefined) {
        return undefined;
    }
    let text = getPokerText(i);
    let suit = getPokerSuit(i);

    return { text, suit };
};
const getPokerText = (i: number): string => {
    const n = i % 13;
    switch (n) {
        case 0:
            return 'A';
        case 10:
            return 'J';
        case 11:
            return 'Q';
        case 12:
            return 'K';
        default:
            return (n + 1).toString();
    }
};
const getPokerSuit = (i: number): Suit => {
    switch (true) {
        case i < 13:
            return Suit.SPADE;
        case i < 26:
            return Suit.HEART;
        case i < 39:
            return Suit.CLUB;
        case i < 52:
            return Suit.DIAMOND;
        default:
            return Suit.NONE;
    }
};

export type HostProps = {
    hostId: number;
    gameType: GameTypeEnum;
};
export type BetRecordProps = {
    bet: BetRecord;
};
export type HostRoadmapProps = {
    hostId: number;
    column: number;
    row?: number;
    className?: string;
};
export type HostSvgRoadmapProps = {
    roadmapProps: {
        gameType?: GameTypeEnum;
        hostId: number;
        column?: number;
        row?: number;
        className?: string;
    };
};
export type CheckBetAvailableProp = {
    gameType: number;
    betsSummary: Array<number>;
    MaxBet: Array<BetTypeMaxBet>;
    MinBet: number;
};
export type CheckBetsProp = {
    hostId: number;
    gameType: number;
    bets: Array<Bet>;
    amountOverBetLimit?: (betType: number, chipAmount: number) => number;
    totalPendingBetAmount: number;
    totalPendingWithHoldAmount: number;
    availableBalance: number;
    disableBetTypes?: Array<number>;
    confirmedBets?: Array<Bet>;
    availableAfterHedgeBetting?: boolean;
};
export type AvailableBetsProp = {
    bets: Array<Bet>;
    isAllIn: boolean;
    haveBetLimitAllIn: boolean;
    isOutOfBetLimit: boolean;
    isNotEnoughMoney: boolean;
    haveDisabledBetType: boolean;
};

const getUnavailableBetsForABC = ({
    betsSummary,
    MaxBet,
    MinBet,
}: CheckBetAvailableProp): Array<number> => {
    let unavailableBetTypes = new Array<number>();
    betsSummary.forEach((amount, index) => {
        let itemMax = MaxBet.findIndex(d => {
            return d.BetType === index;
        });
        if (amount < MinBet) {
            unavailableBetTypes.push(index);
        } else if (amount > MaxBet[itemMax].MaxBet) {
            unavailableBetTypes.push(index);
        }
    });
    return unavailableBetTypes;
};
export const checkUnavailableBetsForABC = (
    props: CheckBetAvailableProp
): Array<number> => {
    const { gameType, betsSummary, MaxBet, MinBet } = props;
    switch (gameType) {
        case GameTypeEnum.Baccarat:
            return getBaccaratUnavailableBetsForABC(
                betsSummary,
                MaxBet,
                MinBet
            );
        case GameTypeEnum.SeDie:
            return getSeDieUnavailableBetsForABC(betsSummary, MaxBet, MinBet);
        case GameTypeEnum.AndarBahar:
            return getAndarBaharUnavailableBetsForABC(
                betsSummary,
                MaxBet,
                MinBet
            );
        case GameTypeEnum.TeenPatti2020:
            return getTeenPatti2020UnavailableBetsForABC(
                betsSummary,
                MaxBet,
                MinBet
            );
        default:
            return getUnavailableBetsForABC(props);
    }
    //getAndarBaharHedgeBettingBets(bets);
    //getTeenPatti2020HedgeBettingBets(bets);
};
export const checkBetsAvailed = (props: CheckBetsProp): AvailableBetsProp => {
    let isAllIn: boolean = false;
    let haveBetLimitAllIn = false;
    let isOutOfBetLimit = false;
    let isNotEnoughMoney = false;
    let haveDisabledBetType = false;
    let newBets = new Array<Bet>();

    let currentPendingBetAmount = 0;
    let currentWithHoldAmount = 0;
    const withHold = getWithHold(props.gameType);
    for (let bet of props.bets) {
        if (props.disableBetTypes) {
            if (props.disableBetTypes.indexOf(bet.Type) >= 0) {
                haveDisabledBetType = true;
                continue;
            }
        }

        // check over bet limit
        let amount = bet.Amount;
        if (props.amountOverBetLimit) {
            const overLimit =
                props.availableAfterHedgeBetting === true
                    ? 0
                    : props.amountOverBetLimit(bet.Type, amount);
            if (overLimit > 0) {
                if (amount <= overLimit) {
                    isOutOfBetLimit = true;
                    break;
                } else {
                    amount -= overLimit;
                    haveBetLimitAllIn = true;
                }
            }

            let pendingBetAmount = amount;
            let withHoldRate = 0;
            if (withHold) {
                const tmp = withHold.find(lr => lr.Type === bet.Type);
                if (tmp) {
                    withHoldRate = tmp.Amount;
                }
            }
            if (
                props.totalPendingBetAmount +
                    props.totalPendingWithHoldAmount +
                    currentPendingBetAmount +
                    currentWithHoldAmount +
                    pendingBetAmount +
                    pendingBetAmount * withHoldRate >
                props.availableBalance * 100
            ) {
                pendingBetAmount =
                    Math.floor(props.availableBalance) * 100 -
                    props.totalPendingBetAmount -
                    props.totalPendingWithHoldAmount -
                    currentPendingBetAmount -
                    currentWithHoldAmount;
                if (withHoldRate > 0 && pendingBetAmount > 0) {
                    pendingBetAmount =
                        Math.floor(
                            pendingBetAmount / (withHoldRate + 1) / 100
                        ) * 100;
                }
                if (pendingBetAmount <= 0) {
                    isNotEnoughMoney = true;
                    break;
                }
                isAllIn = true;
            }
            let newBet = { ...bet };
            newBet.Amount = pendingBetAmount;
            newBets.push(newBet);
            currentPendingBetAmount += pendingBetAmount;
            currentWithHoldAmount += pendingBetAmount * withHoldRate;
        }
    }
    return {
        bets: newBets,
        isAllIn: isAllIn,
        haveBetLimitAllIn: haveBetLimitAllIn,
        isOutOfBetLimit: isOutOfBetLimit,
        isNotEnoughMoney: isNotEnoughMoney,
        haveDisabledBetType: haveDisabledBetType,
    };
};

export const getWithHoldBetAmount = (
    gameType: GameTypeEnum,
    betSummary: Array<number>
) => {
    const withHold = getWithHold(gameType);
    let total = 0;
    if (withHold) {
        withHold.forEach(b => {
            total += betSummary[b.Type] ? betSummary[b.Type] * b.Amount : 0;
        });
    }
    return total;
};

export const getLocalState = (
    gameType: GameTypeEnum,
    isRest: boolean,
    state: number,
    resultReleased: boolean,
    isRoundCancel: boolean,
    isMsgPopup: boolean
) => {
    switch (gameType) {
        case GameTypeEnum.Baccarat:
            return getBaccaratLocalState(
                isRest,
                state,
                resultReleased,
                isRoundCancel ? isRoundCancel : false
            );
        case GameTypeEnum.Dragon:
            return getDTLocalState(
                isRest,
                state,
                resultReleased,
                isRoundCancel ? isRoundCancel : false
            );
        case GameTypeEnum.SeDie:
            return getSeDieLocalState(
                isRest,
                state,
                resultReleased,
                isMsgPopup
            );
        case GameTypeEnum.SicBo:
            return getSicBoLocalState(isRest, state, resultReleased);
        case GameTypeEnum.ThaiHiLo:
            return getThaiHiLoLocalState(isRest, state, resultReleased);
        case GameTypeEnum.FishPrawnCrab:
            return getFishPrawnCrabLocalState(isRest, state, resultReleased);
        case GameTypeEnum.AndarBahar:
            return getAndarBaharLocalState(
                isRest,
                state,
                resultReleased,
                isRoundCancel ? isRoundCancel : false
            );
        case GameTypeEnum.TeenPatti2020:
            return getTeenPattiLocalState(
                isRest,
                state,
                resultReleased,
                isRoundCancel ? isRoundCancel : false
            );
        case GameTypeEnum.UltraRoulette:
        case GameTypeEnum.Roulette:
            return getRouletteLocalState(isRest, state, resultReleased);
        case GameTypeEnum.PokDeng:
            return getPokDengLocalState(
                isRest,
                state,
                resultReleased,
                isRoundCancel ? isRoundCancel : false
            );
        case GameTypeEnum.Blackjack:
            return getBlackjackLocalState(
                isRest,
                state,
                resultReleased,
                isRoundCancel ? isRoundCancel : false
            );
        case GameTypeEnum.Blackjack2:
            return getBlackjack2LocalState(
                isRest,
                state,
                resultReleased,
                isRoundCancel ? isRoundCancel : false
            );
        case GameTypeEnum.CarnivalTreasure:
            return getCarnivalTreasureLocalState(isRest, state, resultReleased);
    }
    return GameState.Idle;
};

// export const getRandomId = (length: number) => {
//     const randomId = new Uint8Array(length);
//     window.crypto.getRandomValues(randomId);
//     return convertToHex(randomId);
// };
// export const convertToHex = (array: Uint8Array) => {
//     const result = new Array<string>();
//     for (const a of array) {
//         const s = a.toString(16);
//         result.push(s.length === 2 ? s : '0' + s);
//     }
//     return result.join('');
// };

export const formatBetLimit = (n: number) =>
    n.toLocaleString('en-US', { maximumFractionDigits: 2 });

export const getMaxBetByBetType = (
    betType: number,
    MaxBet: BetTypeMaxBet[]
): string => {
    if (!MaxBet) return '0';
    const index = MaxBet.findIndex(d => {
        return d.BetType === betType;
    });
    return index !== -1 ? formatBetLimit(MaxBet[index].MaxBet / 100) : '0';
};
const getDefaultImageIdx = (
    gameType: GameTypeEnum,
    hallId: HallEnum,
    isTopView = false
): VideoImageEnum | undefined => {
    switch (gameType) {
        case GameTypeEnum.AndarBahar:
            return VideoImageEnum.bg_andar_bahar_mtable;
        case GameTypeEnum.Baccarat:
            if (hallId == HallEnum.Diamond) {
                return VideoImageEnum.bg_baccarat_atable;
            } else if (hallId == HallEnum.Sexy) {
                return VideoImageEnum.bg_baccarat_ctable;
            } else if (hallId == HallEnum.Ruby) {
                return VideoImageEnum.bg_baccarat_mtable;
            } else {
                return VideoImageEnum.bg_baccarat_mtable;
            }
        case GameTypeEnum.Blackjack:
            if (hallId == HallEnum.Diamond) {
                return VideoImageEnum.bg_blackjack_atable;
            }
            return VideoImageEnum.bg_blackjack_mtable;
        case GameTypeEnum.Blackjack2:
            if (hallId == HallEnum.Diamond) {
                return isTopView
                    ? VideoImageEnum.bg_blackjack2_atable_zoom
                    : VideoImageEnum.bg_blackjack2_atable;
            }
            return isTopView
                ? VideoImageEnum.bg_blackjack2_mtable_zoom
                : VideoImageEnum.bg_blackjack2_mtable;
        case GameTypeEnum.Dragon:
            if (hallId == HallEnum.Diamond) {
                return VideoImageEnum.bg_dragontiger_atable;
            }
            return VideoImageEnum.bg_dragontiger_mtable;
        case GameTypeEnum.PokDeng:
            if (hallId == HallEnum.Diamond) {
                return VideoImageEnum.bg_pokdeng_atable;
            }
            return VideoImageEnum.bg_pokdeng_mtable;
        case GameTypeEnum.Roulette:
        case GameTypeEnum.UltraRoulette:
            if (hallId == HallEnum.Sexy) {
                return VideoImageEnum.bg_roulette_ctable;
            } else if (hallId == HallEnum.Diamond) {
                return VideoImageEnum.bg_roulette_atable;
            } else {
                return VideoImageEnum.bg_roulette_mtable;
            }
        case GameTypeEnum.SeDie:
            if (hallId == HallEnum.Diamond) {
                return VideoImageEnum.bg_sedie_atable;
            }
            return VideoImageEnum.bg_sedie_mtable;
        case GameTypeEnum.SicBo:
        case GameTypeEnum.ThaiHiLo:
            if (hallId == HallEnum.Diamond) {
                return VideoImageEnum.bg_sicbo_atable;
            }
            return VideoImageEnum.bg_sicbo_mtable;
        case GameTypeEnum.TeenPatti2020:
            return VideoImageEnum.bg_teen_patti_mtable;
        case GameTypeEnum.FishPrawnCrab:
            return VideoImageEnum.bg_fishprawncrab_mtable;
        case GameTypeEnum.CarnivalTreasure:
            return VideoImageEnum.bg_carnival_treasure_rtable;
    }
    return undefined;
};

export const getDefaultImage = (
    gameType: GameTypeEnum,
    hallId: HallEnum,
    isTopView = false
) => {
    const idx = getDefaultImageIdx(gameType, hallId, isTopView);
    if (idx !== undefined) {
        return getVideoImage(idx);
    }
    return <></>;
};

export const getDefaultImageSrc = (
    gameType: GameTypeEnum,
    hallId: HallEnum
) => {
    const idx = getDefaultImageIdx(gameType, hallId);
    if (idx !== undefined) {
        return getVideoImageSrc(idx);
    }
    return 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=';
};

export const getVHByRem = (rem: number) => {
    return `max(calc(var(--vh) * ${rem * 3}), ${rem}rem)`;
};

export const getVHByRemToNumber = (vh: number, rem: number) => {
    return Math.max(vh * rem * 3, rem * 16); //`max(calc(var(--vh) * ${rem * 3}), ${rem}rem)`;
};

export const getVWByRem = (rem: number) => {
    return `max(calc(var(--vw) * ${rem * 3}), ${rem}rem)`;
};

export const getEnumValues = (customEnum: object) =>
    Object.values(customEnum)
        .map(bte => Number(bte))
        .filter(bte => !isNaN(bte)) ?? new Array<number>();
